import { createFileRoute } from '@tanstack/react-router'

import { Perfil } from '@/components/perfil/Perfil'

export const Route = createFileRoute('/_auth/perfil')({ component: Perfil })
